module.exports = __webpack_public_path__ + "static/media/SpaceOverview.f2a46f7b.jpg";